import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import type { User } from "@/lib/types/user";
import flatfileLogo from "@/public/images/flatfile-logo.svg";

export function AccountReview() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkUserStatus = async () => {
      const token = localStorage.getItem("auth_token");
      
      // If no token, redirect to login
      if (!token) {
        navigate("/login", { replace: true });
        return;
      }

      try {
        // Try to get user data
        const userData = await api.get<User>("/user");
        
        // Check if user is now active - redirect to app
        if (userData && userData.state === "active") {
          navigate("/app", { replace: true });
        }
        // If user is inactive, stay on this page (no action needed)
      } catch (error) {
        // If we get an error (no token or invalid token), redirect to login
        console.log("No valid token, redirecting to login");
        navigate("/login", { replace: true });
      }
    };

    checkUserStatus();
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background p-4">
      <div className="w-full max-w-md space-y-8">
        <div className="flex flex-col items-center space-y-2">
          <img 
            src={flatfileLogo} 
            alt="Flatfile" 
            className="h-12 w-auto rounded-sm"
          />
        </div>
        <Card>
          <CardHeader>
            <CardTitle className="text-center">Account Under Review</CardTitle>
            <CardDescription className="text-sm text-center">
              Your account is currently being reviewed by our team.
            </CardDescription>
          </CardHeader>
          <CardContent className="text-center space-y-4">
            <div className="p-6">
              <div className="mb-4">
                <svg
                  className="w-16 h-16 mx-auto text-blue-500 mb-4"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              
              <h3 className="text-lg font-medium text-foreground mb-2">
                Almost There!
              </h3>
              
              <p className="text-sm text-muted-foreground mb-4">
                Thank you for registering. We're currently reviewing your account to ensure the security and quality of our platform.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
